// client/src/hooks/useSiteBrand.js — Florida's branding (or null on Illinois) for the
// staff dashboard and client portal. See utils/siteBrand.js.
import { useEffect, useState } from 'react';
import { siteBrand, siteFromDocument, normaliseSite } from '../utils/siteBrand';

let pending = null;            // one request per page load, shared by every caller
const askServer = () => {
    if (!pending) {
        pending = fetch('/api/public/jurisdiction')
            .then((r) => (r.ok ? r.json() : null))
            .then((j) => normaliseSite(j && j.code))
            .catch(() => 'IL');
    }
    return pending;
};

export default function useSiteBrand() {
    const [code, setCode] = useState(() => siteFromDocument(typeof document !== 'undefined' ? document : null));
    useEffect(() => {
        if (code) return undefined;
        let live = true;
        askServer().then((c) => { if (live) setCode(c); });
        return () => { live = false; };
    }, [code]);
    return siteBrand(code);
}

/** The slim "Florida" bar at the very top of the dashboard and the client portal. */
export function SiteBar({ brand, style }) {
    if (!brand) return null;
    return (
        <div role="note" aria-label={`${brand.label} site`} style={style}
             className={`${brand.barClass} text-center text-xs font-semibold uppercase tracking-wider leading-5`}>
            {brand.label}
        </div>
    );
}
